<template>
  <section class="section">
    <div class="container mt-5">
      <div class="page-error">
        <div class="page-inner">
          <h1>403</h1>
          <div class="page-description">
            Anda tidak memiliki izin akses
          </div>
          <div class="page-search">
            <div class="mt-3">
              <router-link to="/">
                Kembali ke web
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="simple-footer mt-5">
        Copyright &copy; 2021
      </div>
    </div>
  </section>
</template>

<script>
export default {
	created() {
		window.history.pushState("", "", '/')
		document.querySelector('title').innerHTML = '403 | ' + this.$store.getters.getAppName
	}
}
</script>